import { Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

import { getTheme } from '@commons/utils/theme';

import { getIconButtonStyle, getMenuStyle, getPictureStyle } from './styledComponents';

const getIcon = (image, disabled) => {
  if (image) {
    return image;
  }

  if (disabled) {
    return '/images/inpulse/add-a-photo-lmgrey.svg';
  }

  return '/images/inpulse/add-a-photo-black.svg';
};

const PictureWithActions = ({ image = null, actions = [], disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = getTheme();

  const open = !!anchorEl;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        alt="open-picture"
        aria-controls={open && 'basic-menu'}
        aria-expanded={open && 'true'}
        aria-haspopup="true"
        disabled={disabled}
        sx={getIconButtonStyle(theme, disabled, !!image)}
        onClick={handleClick}
      >
        <Avatar
          alt="open-picture"
          // Disable hover effect if there is an image
          className={image ? '' : 'picture'}
          src={getIcon(image, disabled)}
          sx={getPictureStyle(!!image)}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="basic-menu"
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        open={open}
        sx={getMenuStyle(theme)}
        onClose={handleClose}
      >
        {actions.map((action) => (
          <MenuItem
            // Enable seeing or deleting the picture if it exists
            // Replacing action is always available
            disabled={action.id !== 'replace-picture' && !image}
            key={action.id}
            onClick={() => {
              action.handleClick();
              handleClose();
            }}
          >
            {action.render}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default PictureWithActions;
